import * as React from 'react'
import {ReactElement} from 'react'
import {createErrorHandlingForm, ErrorHandlingFormProps} from './hoc/createErrorHandlingForm'
import {EnterKeyHandlerProps, withEnterKeyHandler} from './hoc/withEnterKeyHandler'
import styled from 'styled-components'
import {StyledLabel} from '../../../styledComponents/StyledTypeDefinitions'
import { StandardTextFieldProps } from '@mui/material/TextField';
import {StylesProvider} from '@mui/styles'
import { InputProps as StandardInputProps, Button, TextField } from '@mui/material';

interface State {
    fileName: string
}

interface Props {
    inputRef?: React.Ref<any>
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
    fileName?: string
    id?: string
}

class PPFileInput
    extends React.Component<Props & StandardTextFieldProps & ErrorHandlingFormProps & EnterKeyHandlerProps, State> {

    static displayName: string = 'PPFileInput'

    constructor(props: Props & StandardTextFieldProps & ErrorHandlingFormProps & EnterKeyHandlerProps) {
        super(props)
        this.state = {fileName: ''}

        this.onChangeFile = this.onChangeFile.bind(this)
        this.onClickFileUpload = this.onClickFileUpload.bind(this)
    }

    componentDidUpdate(prevProps: Props): void {
        if (prevProps.fileName !== undefined && this.props.fileName !== undefined &&
            prevProps.fileName !== this.props.fileName) {
            this.setState({fileName: this.props.fileName})
        }
    }

    getInputId(): string {
        return this.props.id ? 'fileUpload' + this.props.id : 'fileUpload'
    }

    onClickFileUpload(): void {
        const id = this.getInputId()
        const fileUpload = document.getElementById(id) as HTMLInputElement
        fileUpload.value = '';
        if (fileUpload) {
            fileUpload.click()
        }
    }

    onChangeFile(event: React.ChangeEvent<HTMLInputElement>): void {
        try {
            if (this.props.onChange) {
                this.props.onChange(event)
            }
        } finally {
            const id = this.getInputId()
            const fileUpload = document.getElementById(id) as HTMLInputElement
            if (fileUpload) {
                const file = fileUpload.files
                if (file && file[0]) {
                    this.setState({fileName: file[0].name})
                } else {
                    this.setState({fileName: ''})
                }
            }
        }
    }

    render(): ReactElement {
        const {
            hasError, messages, clearErrorMessage, eventKeys,
            eventEmitter, inputRef, fileName, onChange, ...rest
        } = this.props

        if ({...rest}.InputProps) {
            const inputProps: Partial<StandardInputProps> | undefined = {...rest}.InputProps
            if (inputProps !== undefined && inputProps.inputProps !== undefined) {
                inputProps.inputProps.tabIndex = -1
                inputProps.inputProps.readOnly = true
            }
        }

        return (
            <StylesProvider injectFirst>
                <FileUploadContainer onClick={this.onClickFileUpload} fullWidth={this.props.fullWidth}>
                    <FilePathItem>
                        <StyledTextField
                            size={'small'}
                            variant={'outlined'}
                            value={this.state.fileName}
                            {...rest}
                            error={hasError}
                        />
                    </FilePathItem>
                    <Button color={'info'} variant={'contained'} size={'small'} disabled={this.props.disabled}>
                        参照...
                    </Button>
                    <DisplayNoneInput
                        type={'file'} id={this.getInputId()}
                        ref={this.props.inputRef}
                        onChange={this.onChangeFile}
                        disabled={this.props.disabled}/>
                </FileUploadContainer>
            </StylesProvider>
        );
    }
}

export default createErrorHandlingForm(withEnterKeyHandler(PPFileInput))

const StyledTextField = styled(TextField)`
  &.MuiFormControl-root {
    width: 100%;
  }

  & .MuiInputAdornment {
    margin-bottom: 5px;
  }

  &.MuiTextField-root > div {
    height: 29px;
    background-color: #e0e0e0;
  }

  & .MuiOutlinedInput-inputMarginDense {
    padding-top: 5.5px;
    padding-bottom: 6px;
  }
`

const FileUploadContainer = styled.div<FullWidth>`
  display: flex;
  ${props => (props.fullWidth) && props.fullWidth ? `
      flex: 1 0 auto;
   ` : ``};
  align-items: flex-end;
`

const FilePathItem: StyledLabel = styled.label`
  flex: 1 0 auto;
  padding-right: 5px;
`

const DisplayNoneInput = styled.input`
  display: none;
`

interface FullWidth {
    fullWidth?: boolean;
}
